import React from 'react';
import Divider from '@material-ui/core/Divider';
import styled from 'styled-components/macro';
import Markdown from '../../Markdown';
import Description from '../Description';

const Instructions = styled.div`
  margin-top: 0.8em;
  ${({ $length }) => !$length && 'margin: 0;'}
  p {
    font-size: 14px;
    padding-bottom: 0.8em;
  }

  li {
    font-size: 14px;
  }
`;

const InstructionalTextFieldView = props => {
  return (
    <>
      <Divider />
      <Instructions
        $length={props.title ? props.title.length : 0}
        role="instructional-text-title"
      >
        {props.title
          .trim()
          .split('\n')
          .map((line, i) => (
            <Markdown key={i} content={line} />
          ))}
      </Instructions>
      {props.isUsingDescriptionLogic ? (
        props.description.map(d => (
          <Description
            key={d.id}
            fontSize={14}
            content={d.description}
            id={d.id}
          />
        ))
      ) : (
        <Description fontSize={14} content={props.description} />
      )}
    </>
  );
};

export default InstructionalTextFieldView;
